import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentoSalidaService } from '../../services/documento-salida.service';
import { DocumentoSalida } from '../../model/documento-salida';
import { ConsorciosService } from '../../services/consorcios.service';
import { Consorcio } from '../../model/consorcio';
import { SucursalService } from '../../services/sucursal.service';
import { Sucursal } from '../../model/sucursal';

import { SocioService } from '../../services/socio.service';
import { Socio } from '../../model/socio';

import { SubirDocumentosService } from '../../services/subir-documentos.service';
import { DocumentoSalidaMantenimientoComponent } from '../../components/documento-salida-mantenimiento/documento-salida-mantenimiento.component';

import { DocumentoArchivoSubirResultadoComponent } from '../../components/documento-archivo-subir-resultado/documento-archivo-subir-resultado.component';
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-documento-salida-list',
  templateUrl: './documento-salida-list.component.html',
  styleUrls: ['./documento-salida-list.component.css']
})

export class DocumentoSalidaListComponent implements OnInit {

  @ViewChild(DocumentoSalidaMantenimientoComponent) _mantenimientoComponent: DocumentoSalidaMantenimientoComponent;
  @ViewChild(DocumentoArchivoSubirResultadoComponent) _resultado: DocumentoArchivoSubirResultadoComponent;



  public modoEdicion: boolean = false;

  public consorcio: Consorcio;
  public consorcios: Consorcio[];

  public sucursal: Sucursal;
  public sucursales: Sucursal[];

  public documento: DocumentoSalida;
  public documentos: DocumentoSalida[];

  public codigoSucursal: string;

  public socios: Socio[];
  public socio: Socio;

  public query: any;
  public documentoSeleccionado: DocumentoSalida;

  public ArchivoCargado: boolean = false;
  public NombreArchivo: string = "";
  public csv: any;

  public buscando: boolean = false;



  public verResultadoCarga: boolean;

  public _guid: string;
  public _cantidadLineas: number;
  public _cantidadLineasEnviadas: number;
  public char_separador: string = ",";

  public filtro = "";

  constructor(
    private _documentoSalidaService: DocumentoSalidaService,
    private _consorcioService: ConsorciosService,
    private _sucursalService: SucursalService,
    private _socioService: SocioService,
    private _subirDocumentosService: SubirDocumentosService
  ) { }

  ngOnInit() {

    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.filtro = "";
    this.documentos = [];
    this.codigoSucursal = "";
    this.consorcio = null;
    this.sucursal = null;
    this.documentoSeleccionado = new DocumentoSalida();
    this.cargarConsorcios();

  }

  descargarFormato() {
    document.getElementById('Link_File').click();
  }

  asignarClientes() {
    for (let i = 0; i < this.documentos.length; i++) {
      for (let x = 0; x < this.socios.length; x++) {
        if (this.documentos[i].codigoCliente === this.socios[x].codigoSocio) {
          this.documentos[i].nombreCliente = this.socios[x].nombre;
        }
      }
    }
  }

  cargarClientes() {
    this.query = {
      "codigoConsorcio": this.consorcio.codigoConsorcio,
      "tipo": "CLIENTE"
    };

    this._socioService.getSocios(this.query)
      .subscribe(
        data => {
          this.socios = data;
          this.asignarClientes();
        },
        err => {
          console.clear();
          console.log(err._body);
        });
  }

  refrescar() {

    if (this.consorcio === null || this.codigoSucursal === "") {
      return;
    }
    this.cargarDocumentos();

  }

  cargarConsorcios() {
    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
        data => { this.consorcios = data; },
        err => {
          console.log(err);
        });
  }

  cargarSucursales() {

    if (this.consorcio === null) {
      return;
    }
    this.query = { "email": sessionStorage.getItem("login"), "codigoConsorcio": this.consorcio.codigoConsorcio }

    this._sucursalService.getSucursalesUsuario(this.query)
      .subscribe(
        data => this.sucursales = data,
        err => {
          console.clear();
          console.log(err._body);
        });
  }


  agregarRegistro() {
    if (this.consorcio === null || this.sucursal === null) {
      return;
    }
    this.modoEdicion = true;
    this._mantenimientoComponent.agregarDocumento(this.consorcio, this.sucursal);
  }

  regresar() {
    this.modoEdicion = false;
    this.cargarDocumentos();
  }

  cargarDocumentos() {

    if (this.consorcio === null || this.sucursal === null) {
      return;
    }

    this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      codigoSucursal: this.sucursal.codigoSucursal
    };
    this._documentoSalidaService.getDocumentosExtradaData(this.consorcio.codigoConsorcio, this.sucursal.codigoSucursal)
      .subscribe(
        data => {
          this.documentos = data;
          this.cargarClientes();
          //  this.cargarDocumentosDatosExtra(this.documentos);


        },
        err => {
          console.clear();
          console.log(err._body);
        });


  }

  editarRegistro(documento: DocumentoSalida) {
    this.modoEdicion = true;
    this._mantenimientoComponent.editarDocumento(this.consorcio, this.sucursal, documento);
  }

  onChangeFile(event) {
    this.ArchivoCargado = true;
    var file = event.target.files[0] || event.srcElement.files[0];
    this.NombreArchivo = file.name;
    this.csv = file;
  }

  guardarArchivo(arr: any, service: SubirDocumentosService) {
    this._subirDocumentosService.insert(arr)
      .subscribe(
        data => {
          alert("El archivo ha sido cargado...");
          this.cargarDocumentos();
        },
        err => {
          console.log(err._body);
        });
  }

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  prepararEnvio(arrDoc: any, arrSync: any, arrDocID: any) {

    if (arrSync.length > 0) {
      for (var i = 0; i < arrSync.length; i++) {
        delete arrDoc[this.findIndex(arrDoc, arrSync[i], "ID_SYNC")];
        arrDoc.sort();
        arrDoc.length = arrDoc.length - 1;
        this._cantidadLineasEnviadas = this._cantidadLineasEnviadas + 1;
      }
    }

    if (arrDoc.length > 0) {
      var arrToSync = [];
      if (arrDoc.length > 100) {
        for (var x = 0; x < 100; x++) {
          arrToSync.push(arrDoc[x]);
        }
      } else {
        arrToSync = arrDoc;
      }

      this._subirDocumentosService.insertNuevo(arrToSync)
        .subscribe(
          data => {

            if (data.tipoResultado === 'ERROR') {
              alert('Ha ocurrido un error, ' + data.mensaje);
              return;
            }


            this.prepararEnvio(arrDoc, data.objetoResultado, arrDocID);
          },
          err => {
            console.log(err._body);
          });
    } else {
      if (this._cantidadLineas === this._cantidadLineasEnviadas) {
        this._subirDocumentosService.confirmar(this._guid)
          .subscribe(
            data => {
              alert("El archivo ha sido cargado...");
              this.buscando = false;
              this.cargarDocumentos();
              this.obtenerResultadoSubidos();
            },
            err => {
              this.buscando = false;
              console.log(err._body);
              alert("Error revise la consola");
            });
      } else {
        alert("Error al subir el archivo:  Diferencia en la cantidad de líneas por subir...");
        this._subirDocumentosService.RevertirSubida({ "ID_Session": this._guid });
        this.buscando = false;
        this.cargarDocumentos();
      }

    }


  }

  asignarCliente() {
    for (let i = 0; i < this.documentos.length; i++) {
      for (let x = 0; x < this.socios.length; i++) {
        if (this.documentos[i].codigoCliente === this.socios[x].codigoSocio) {
          this.documentos[i].nombreCliente = this.socios[x].nombre;
        }
      }
    }
  }


  obtenerResultadoSubidos() {

    this._resultado.cargarDatos(this._guid);

    this.verResultadoCarga = true;


  }

  cambiarSeparador() {
    if (this.char_separador === ",") {
      this.char_separador = ";";
    } else {
      this.char_separador = ",";
    }
  }


  volverDocumentos() {

    this.verResultadoCarga = false;

  }

  findIndex(arr, query, property) {
    for (var i = 0, len = arr.length; i < len; i++) {
      if (arr[i][property] === query) return i;
    }
    return -1;
  }

  cargarArchivo() {

    // if (this.socio === null) {
    //   return;
    // }
    this.ArchivoCargado = false;
    var guardar = this.guardarArchivo;
    var servicio = this._subirDocumentosService;
    var oFReader = new FileReader();
    var retorno = false;

    oFReader.onloadend = (e) => {

      this._guid = this.guid();

      var Lines = oFReader.result.split("\n");
      var Headers = Lines[0].replace(/"/g, '').split(this.char_separador);
      var arr = [];
      var arr_Articulos = [];
      var arr_Doc = [];
      for (var i = 1; i < ((Lines.length) - 1); i++) {
        var patt = new RegExp(this.char_separador + this.char_separador);
        //if (!patt.test(Lines[i])) {
        var Current_Line = Lines[i].replace(/"/g, '').split(this.char_separador);
        var Obj = {};
        Obj["ID_SYNC"] = i;
        for (var j = 0; j < Headers.length; j++) {
          if (Headers[j] === "CANTIDAD") {
            Obj[Headers[j].replace(/"/g, '')] = parseInt(Current_Line[j]);
          } else {
            Obj[Headers[j].replace(/"/g, '')] = Current_Line[j];
          }
        }
        if (Obj["TIPODOCUMENTO"] != "EXP") {
          alert("El documento no pertenece a una Expedición");
          retorno = true;
          break;
        }

        if (!/this.consorcio.documentoPrefijo/.test(Obj["CODIGODOCUMENTO"])) {
          Obj["CODIGODOCUMENTO"] = this.consorcio.documentoPrefijo + "-" + Obj["CODIGODOCUMENTO"];
        }
        Obj["SESION"] = this._guid;
        Obj["CODIGOBODEGA"] = this.consorcio.codigoBodega;
        Obj["CODIGOCONSORCIO"] = this.consorcio.codigoConsorcio;
        //   Obj["CODIGOCLIENTE"] = this.socio.codigoSocio;
        Obj["CODIGOSUCURSAL"] = this.sucursal.codigoSucursal;
        Obj["TIPO"] = "SALIDA";
        Obj["FECHA"] = Obj["FECHA"].replace(/\//g, '-');

        // if (Obj['ORDEN_ORIGINAL'] === '') {

        // } else {
        //   if (!isNullOrUndefined(Obj['ORDEN_ORIGINAL']) || Obj['ORDEN_ORIGINAL'] === '') {
        //     Obj['ORDEN_ORIGINAL'] = this.consorcio.documentoPrefijo + '-' + Obj['ORDEN_ORIGINAL'];
        //   }
        // }



        arr.push(Obj);
        arr_Articulos.push({ "codigoArticulo": Obj["CODIGOARTICULO"] });
        if (this.findIndex(arr_Doc, Obj["CODIGODOCUMENTO"], "CODIGODOCUMENTO")) {
          arr_Doc.push({ "TIPO": "SALIDA", "CODIGODOCUMENTO": Obj["CODIGODOCUMENTO"] });
        }
        // }

      }

      if (retorno) {
        return;
      } else {
        this._cantidadLineas = arr.length;
        this._cantidadLineasEnviadas = 0;
        this.buscando = true;
        this.prepararEnvio(arr, [], arr_Doc);
      }
    }
    oFReader.readAsText(this.csv, 'ISO-8859-1');
  }


  buscarArchivo() {
    if (this.consorcio === null || this.sucursal === null) {
      return;
    }
    document.getElementById("Button_File").click();
  }

  cargarDocumentosDatosExtra(documentosSalida: DocumentoSalida[]) {

    this._documentoSalidaService.getDocumentosExtradaData(this.consorcio.codigoConsorcio,
      this.sucursal.codigoSucursal).subscribe(data => {

        for (let index = 0; index < documentosSalida.length; index++) {
          const element = documentosSalida[index];
          const elementDataExtra = data.find(f => f.codigoDocumento === element.codigoDocumento);

          if (element.id === elementDataExtra.id) {
            element.ordenOriginal = elementDataExtra.ordenOriginal;
          }

        }


      }, error => {
        console.log(error);
      });

  }

}


// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/documento-salida-list/documento-salida-list.component.ts